module.exports = __webpack_public_path__ + "img/f40.59b15f25.jpg";